<template>
  <div :class="['calculator', { 'calc-mob': isMobile, container: !isMobile }]">
    <breadcrumb v-if="!isMobile" crumb="calculator" />
    <calculator-form />
    <el-card class="recommend">
      <el-row
        :type="isMobile ? '' : 'flex'"
        justify="space-between"
        align="middle"
      >
        <h2 class="tt-up">Рекомендуемая цена водителю</h2>
        <p class="tt-up"><b>0,35 руб/кг</b></p>
      </el-row>
    </el-card>
    <results-lists />
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import CalculatorForm from './components/CalculatorForm'
import ResultsLists from './components/ResultsLists'

export default {
  name: 'Calculator',
  components: { Breadcrumb, CalculatorForm, ResultsLists },
}
</script>

<style lang="sass">
.calculator
  .el-card
    font-size: 18px
    line-height: 1
    color: #000
    padding: 10px 30px
    margin-bottom: 50px
    h2
      margin: 0
      font-size: 18px
      line-height: 1
    &.recommend
      p
        font-size: 48px
        color: #00B754
        margin: 0
  &.calc-mob
    padding-bottom: 50px
    .el-card
      padding: 10px 0
      margin-bottom: 30px
      font-size: 16px
      h2
        font-size: 16px
      &.recommend
        p
          font-size: 24px
          margin-top: 20px
</style>
